<template>
    <div>
        <b-container>
            <!-- Fake call to setup filters -->
            {{setupPrices}}
            <b-row>
                <b-col>
                    <b-button size="sm" variant="warning" style="" @click="resetFilter()">Reset Filter</b-button>
                </b-col>
            </b-row>
            <hr>

            <!-- Containers -->
            <b-row>
                <b-col style="">
                    <h5>Containers</h5>
                </b-col>
            </b-row>
            <b-row>
            <template  v-for="container in getContainers">
                <b-col :key='container.name' >
                    <b-button block :variant="container.buttonSuffix+'success'" style="margin-top:5px;" @click="clickedContainer(container.name)">{{container.display}}</b-button>
                </b-col>
            </template>
            </b-row>
            <hr>

            <!-- Price -->
            <b-row>
                <b-col>
                    <h5>Price</h5>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-input-group prepend="Min" class="mt-1">
                        <b-form-input v-model="minPrice"  type=number  v-on:change="minPriceChanged"></b-form-input>
                        <b-input-group-append>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col>
                    <b-input-group prepend="Max" class="mt-1">
                        <b-form-input v-model="maxPrice" type=number  v-on:change="maxPriceChanged"></b-form-input>
                        <b-input-group-append>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
            <hr>

            <!-- Drink categories -->
            <b-row>
                <b-col>
                    <h5>Beverage Categories</h5>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                <template  v-for="cat in getDrinkCategories">
                    <b-button size="sm"  :key='cat.cat' style="margin-top:5px; margin-left:10px" :variant="cat.buttonSuffix+'primary'"  @click="clickedCategory(cat.cat)">{{cat.cat}}</b-button>
                </template>
                </b-col>
            </b-row>
            <hr>

            <!-- Styles, only if beer or wine -->
            <b-row v-if="getBeerStyles.length>0">
                <b-col>
                    <h5>Styles</h5>
                </b-col>
            </b-row>
            <b-row>
                <template  v-for="beerstyle in getBeerStyles">
                    <b-button size="sm" :key='beerstyle.style' :variant="beerstyle.buttonSuffix+'primary'" style="margin-top:5px; margin-left:10px" @click="clickedStyle(beerstyle.style)">{{beerstyle.style}}</b-button>
                </template>
            </b-row>
            
        </b-container>
        
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import {filterBeers} from '../search.js'
    import { mainBeerStylesList, wineCategories, drinkCategories } from './Myfunctions'
    export default {
        props: {
            applyFilters: { type: Function },
            closeFilter:{ type: Function },
            beersList: {type: Array},
        },
        components: {
        },
        computed: {
            ...mapState(['userProfile', 'currentUser']),

            getCurrentFilters(){
                //Set max and min price
                if(this.$store.state.beerFilter&&('price' in this.$store.state.beerFilter)){
                    //Change only if user didn't edit
                    if(!this.minPriceChanged) this.minPrice=parseInt(this.$store.state.beerFilter.price.min)
                    if(!this.maxPriceChanged) this.maxPrice=parseInt(this.$store.state.beerFilter.price.max)
                }

                return this.$store.state.beerFilter
            },

            setupPrices(){
                if(this.$store.state.beerFilter&&('price' in this.$store.state.beerFilter)){
                    //Change only if user didn't edit
                    this.minPrice=parseInt(this.$store.state.beerFilter.price.min)
                    this.maxPrice=parseInt(this.$store.state.beerFilter.price.max)
                }
                return
            },
            getDrinkCategories(){
                var catList=[]
                var catInStore=""
                if(this.$store.state.beerFilter&&('cat' in this.$store.state.beerFilter)&&(this.$store.state.beerFilter.cat.length>0)){
                    catInStore=this.$store.state.beerFilter.cat

                } 
                for (var i=0; i<drinkCategories.length; i++){
                    var thisCat={}
                    thisCat.cat=drinkCategories[i]
                    thisCat.isSelected=false
                    thisCat.buttonSuffix="outline-"

                    if (catInStore==thisCat.cat){
                        thisCat.isSelected=true
                        thisCat.buttonSuffix=""

                    } 
                    catList.push(thisCat)

                }
                return catList

                //return drinkCategories

            },

            getContainers(){
                var containerArray=[]
                var barrelObject={}
                //To setup price
                var oldfilters=this.getCurrentFilters

                var filtersInStore = {}
                if(this.$store.state.beerFilter&&('containers' in this.$store.state.beerFilter)) filtersInStore=this.$store.state.beerFilter
                var existingContainers=[]
                if('containers' in filtersInStore) existingContainers=filtersInStore.containers

                barrelObject.name="Barrels"
                barrelObject.display="Kegs"
                barrelObject.image=require("../assets/barrel.png")
                barrelObject.isSelected=false
                barrelObject.buttonSuffix="outline-"
                if(existingContainers.includes('Barrels')){
                    barrelObject.isSelected=true
                    barrelObject.buttonSuffix=""
                } 
                containerArray.push(barrelObject)

                var canObject={}
                canObject.name="Cans"
                canObject.display="Cans"
                canObject.image=require("../assets/can2.png")
                canObject.isSelected=false
                canObject.buttonSuffix="outline-"
                if(existingContainers.includes('Cans')){
                    canObject.isSelected=true
                    canObject.buttonSuffix=""
                } 
                containerArray.push(canObject)

                var bottleObject={}
                bottleObject.name="Bottles"
                bottleObject.display="Bottles"
                bottleObject.image=require("../assets/bottle.png")
                bottleObject.isSelected=false
                bottleObject.buttonSuffix="outline-"
                if(existingContainers.includes('Bottles')){
                    bottleObject.isSelected=true
                    bottleObject.buttonSuffix=""
                } 
                containerArray.push(bottleObject)

                return containerArray
            },
            getBeerStyles(){
                var stylesList=[]

                //Only return styles if cat=beer or wine
                var stylesInStore=[]
                //Style==Beer
                if(this.$store.state.beerFilter.cat=="Beers"){
                    if(this.$store.state.beerFilter&&('styles' in this.$store.state.beerFilter)&&(this.$store.state.beerFilter.styles.length>0)){
                    stylesInStore=this.$store.state.beerFilter.styles

                    } 
                    for (var i=0; i<mainBeerStylesList.length; i++){
                        var thisStyle={}
                        thisStyle.style=mainBeerStylesList[i]
                        thisStyle.isSelected=false
                        thisStyle.buttonSuffix="outline-"

                        if (stylesInStore.includes(thisStyle.style)){
                            thisStyle.isSelected=true
                            thisStyle.buttonSuffix=""

                        } 
                        stylesList.push(thisStyle)

                    }

                }
                //Style==Wine
                if(this.$store.state.beerFilter.cat=="Wines"){
                    if(this.$store.state.beerFilter&&('styles' in this.$store.state.beerFilter)&&(this.$store.state.beerFilter.styles.length>0)){
                    stylesInStore=this.$store.state.beerFilter.styles

                    } 
                    for (var i=0; i<wineCategories.length; i++){
                        var thisStyle={}
                        thisStyle.style=wineCategories[i]
                        thisStyle.isSelected=false
                        thisStyle.buttonSuffix="outline-"

                        if (stylesInStore.includes(thisStyle.style)){
                            thisStyle.isSelected=true
                            thisStyle.buttonSuffix=""

                        } 
                        stylesList.push(thisStyle)

                    }

                }


                return stylesList
            },
            getWineStyles(){

            },

        },
        data() {
            return {
                minPrice:0,
                maxPrice:1000,
                minChanged:false,
                maxChanged:false,
                showActivityIndicator:false,
            }
        },

        methods: {
            //Drink category
            clickedCategory(cat){
                //If one category is selected, disable others
                var filterObject=this.getCurrentFilters
                filterObject.cat=cat
                //Remove styles to clear older selected styles
                var styles=[]
                filterObject.styles=styles
                this.$store.commit('setBeerFilter', filterObject)
                console.log("Set Filter = ")
                console.log(filterObject)


            },

            minPriceChanged(){
                this.minChanged=true
            },
            maxPriceChanged(){
                this.maxChanged=true
            },
            //Add containers to filter object
            clickedContainer(selectedContainer){
                var existingContainers = []
                var filterObject=this.getCurrentFilters

                //Check if filterObject exists
                if(!filterObject) filterObject={}
                //Check if there are any container filters
                if(filterObject&&('containers' in filterObject)){
                    existingContainers = filterObject.containers
                    //Check if already in containers. If already exists, remove
                    const existingIndex = existingContainers.findIndex(item => item === selectedContainer);
                    if(existingIndex>-1) existingContainers.splice(existingIndex, 1)
                    //If doesn't exist, add
                    else existingContainers.push(selectedContainer)
                    filterObject.containers=existingContainers
                }
                else{
                    //No container filters. Add.
                    var arrayContainers=[selectedContainer]
                    filterObject.containers=arrayContainers
                }
                //Setup button style
                this.$store.commit('setBeerFilter', filterObject)

            },
            
            //Add stylet of filter object
            clickedStyle(style){
                var stylesArray = []
                var filterObject=this.getCurrentFilters
                //Check if filterObject exists
                if(!filterObject){
                    //Does not exist. Add styles to it and return
                    filterObject={}
                    stylesArray.push(style)
                } 
                //Check if there are existing styles
                else if('styles' in filterObject){
                    //Check if style already exists. If it exists, remove if
                    stylesArray=filterObject.styles
                    const existingStyleIndex = stylesArray.findIndex(item => item === style);
                    //If it exists, remove
                    if(existingStyleIndex>-1) stylesArray.splice(existingStyleIndex,1)
                    //Else, append to styles
                    else stylesArray.push(style)
                }
                //If styles object didn't exist, create and append
                else {
                    stylesArray.push(style)
                }
                filterObject.styles=stylesArray
                this.$store.commit('setBeerFilter', filterObject)
            },

            
            //User clicked apply filters
            clickedfilter(){
                //Check if min/max prices were entered and modify store becore closing modal

                this.showActivityIndicator=true
                var filterObject=this.getCurrentFilters
                //Check if filterObject exists
                if(!filterObject) filterObject={}

                var priceObject={}
                if(this.minPrice>0){    
                    priceObject.min=parseInt(this.minPrice)
                }
                if(this.maxPrice>0){    
                    priceObject.max=parseInt(this.maxPrice)
                }
                filterObject.price=priceObject
                this.$store.commit('setBeerFilter', filterObject)

                var filteredBeers=filterBeers(this.beersList, filterObject)
                this.showActivityIndicator=false
                this.applyFilters(filteredBeers)
            },


            //User clicked cancel filters
            clickedClose(){
                this.closeFilter()
            },
            resetFilter(){
                this.minChanged=false
                this.maxChanged=false
                var filterObject={}
                var containers=[]
                var styles=[]
                var cat=""
                var price={min:0, max:1000}
                filterObject.cat=cat
                filterObject.styles=styles
                filterObject.containers=containers
                filterObject.price=price
                this.minPrice=0
                this.maxPrice=1000

                this.$store.commit('setBeerFilter', filterObject)
            },


        },
        mounted(){
        },

        
    }
</script>